<div class="update-controls">
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Update Controls</h2>
      <p-treeTable [value]="tenants"
                   [style]="{'font-size': '0.8em'}" selectionMode="checkbox"
                   [(selection)]="selected" dataKey="key">

        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Master Last Modified Date</th>
            <th>Uploaded Last Modified Date</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
          <tr [ttSelectableRow]="rowNode">
            <td>
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
              <p-treeTableCheckbox [value]="rowNode"></p-treeTableCheckbox>
              {{rowData.name}}
            </td>
            <td>{{rowData.lastModifiedDate | date:"shortDate"}} {{rowData.lastModifiedDate | date:"shortTime"}}</td>
            <td>{{rowData.remoteLastModifiedDate | date:"shortDate"}} {{rowData.lastModifiedDate | date:"shortTime"}}</td>
            <td>{{getStatus(rowData.remoteUploadStatus)}}</td>
          </tr>
        </ng-template>
      </p-treeTable>

      <mat-form-field class="description-form">
        <mat-label>Update Message</mat-label>
          <textarea matInput
                    cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                    [(ngModel)]="comment" ></textarea>
      </mat-form-field>
      <div class="form-group" style="margin-top: 15px;">
        <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onUpdate()">Update</button>
        <img *ngIf="loading"
             src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
        <button mat-raised-button style="border-radius: 6px;" [routerLink]="['/projects']">Cancel</button>
      </div>
</div>
